import axios, { AxiosResponse } from 'axios';
import { GlobalObject, IAccount, ViewConfigResponse } from '../model/account.model';
import { mapToObject } from '../ui/tools/methods';

export default class AccountApi {
  async update(key: IAccount): Promise<AxiosResponse<any>> {
    return axios.put('api/account/updateSubscriber', key);
  }

  async nextApi(globalObject): Promise<AxiosResponse<any>> {
    let obj = {};
    [...globalObject.viewPayload].forEach(([key, value]) => {
      obj = { ...obj, [key]: JSON.stringify(value) };
    });
    return axios.post('api/user/nextStepAccount', { ...globalObject, viewPayload: obj });
  }

  async findSubscription(): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/findSubscriptionsInfo');
  }

  async findSubscriptionByNumber(number): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/findSubscriptionInfobySubscriptionNumber', { params: { SubscriptionNumber: number } });
  }

  async verifPreviousMail(adhesionNumber, mail): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/checkIsValidEmail', { params: { SubscriptionNumber: adhesionNumber, email: mail } });
  }

  async verifyScriptionByNumber(subNumber, value, mode): Promise<AxiosResponse<any>> {
    return axios.post('api/contract/subscriptions/' + subNumber + '/verify-specific', value, { params: { mode } });
  }

  async verifyOTP(subNumber, mode): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/subscriptions/' + subNumber + '/verify-otp', { params: { mode, force: true } });
  }

  async verifyOTPCode(subNumber, value, mode): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/subscriptions/' + subNumber + '/verify-otp', { params: { mode, otp: value } });
  }
}
